import { ClassroomModel, BoardsGroupModel } from '@descomplica/dex-models';
import Enrollments from '../services/Enrollments';
import { setClassroomsGroups } from './boardsgroups';
import { WesterosClassroomType } from '@/models/enrollments/classroom.model';
import i18n from '@/i18n';

export interface ClassroomsGroup {
  name: string;
  description: string;
  classrooms: ClassroomModel[];
}

export const groupClassroomsByType = (classrooms: ClassroomModel[]): ClassroomsGroup[] => {
  const defaultGroup: ClassroomsGroup = {
    name: '',
    description: '',
    classrooms: [],
  };
  const complementaryGroup: ClassroomsGroup = {
    name: i18n.t('complementaries') as string,
    description: '',
    classrooms: [],
  };
  const levelingGroup: ClassroomsGroup = {
    name: i18n.t('leveling') as string,
    description: '',
    classrooms: [],
  };

  classrooms.forEach((classroom) => {
    switch (classroom.type) {
      case 'complementary':
        complementaryGroup.classrooms.push(classroom);
        break;
      case 'leveling':
        levelingGroup.classrooms.push(classroom);
        break;
      default:
        defaultGroup.classrooms.push(classroom);
    }
  });

  const groups = [defaultGroup, complementaryGroup, levelingGroup];
  return groups.filter((group) => group.classrooms.length);
};

export const getClassroomsByCourse = async (courseName: string): Promise<number[]> => {
  if (!courseName) return [];
  return Enrollments.getClassroomsByCourse(courseName);
};

export const filterClassroomsByPeriod = (
  allClassrooms: ClassroomModel[],
  classroomsByPeriod: WesterosClassroomType[],
): (ClassroomModel | undefined)[] => {
  return allClassrooms.reduce((acc: ClassroomModel[], classroom: ClassroomModel) => {
    classroomsByPeriod.forEach((classroomByPeriod: WesterosClassroomType) => {
      if (classroom.id === classroomByPeriod.id) {
        acc.push(classroom);
      }
    });

    return acc;
  }, []);
};

export const groupPostgradClassroomsInModules = (
  classrooms: ClassroomModel[],
  boardsGroups: BoardsGroupModel[],
): ClassroomsGroup[] => {
  if (!classrooms.length || !boardsGroups.length) return [];

  const classroomsWithoutGroup: ClassroomsGroup = {
    name: 'Outros',
    description: '',
    classrooms: [],
  };

  const postgradClassroomsGroups = setClassroomsGroups(classrooms, boardsGroups);

  const classroomsWithGroup = postgradClassroomsGroups.map((group) => group.classrooms).flat();

  classrooms.forEach((classroom) => {
    if (classroom.boards.length && !classroomsWithGroup.includes(classroom)) {
      classroomsWithoutGroup.classrooms.push(classroom);
    }
  });

  const groups = [...postgradClassroomsGroups, classroomsWithoutGroup];

  return groups.filter((group) => group.classrooms.length) as ClassroomsGroup[];
};
